import React, { useState, useEffect } from "react";
import moment from "moment";
import { Redirect } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";

import html2canvas from "html2canvas";
import {
  Button,
  Col,
  Row,
  Container,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import ReactstrapTable from "./../Tables/ReactstrapTable/DataTable";
var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
var customerName = localStorage.getItem("firstName");
var loginId = localStorage.getItem("username");
var companyName = localStorage.getItem("companyName");
let currentDate = moment(new Date()).format("YYYY-MM-DD");
if (loginId === "SJM_Admin@gmail.com") {
  customerName = loginId.toString().replace(":", "").split("@")[0];
}
export default function PrintReportsTextile(props) {
  console.log("props :>> ", props);
  let propsData = props?.location?.state;
  const [data, setData] = useState({
    dynamicInvMessage: props?.location?.state?.dynamicInvMessage,
    reportName: props?.location?.state?.reportName,
    table: [],
    companyName: propsData.companyName || localStorage.getItem("companyName"),
    compNtn: propsData.Ntn || "",
    compStrn: propsData.Strn || "",
    criteria: props?.location?.state?.criteria,
    criteriaString: props?.location?.state?.criteriaString || "All",
    hidePdfBtn: props?.location?.state?.hidePdfBtn || 0,
  });

  const [screenTableData, setScreenTableData] = useState([]);
  useEffect(() => {
    // console.log(props);
    let logInStatus = false;
    const token = localStorage.getItem("token");
    let reportPrintGoBackUrl = localStorage.getItem("reportPrintGoBackUrl");
    console.log(reportPrintGoBackUrl);
    console.log(props?.location?.state?.data);
    // return;
    const screenPrintData = props?.location?.state?.data;
    console.log(screenPrintData);
    if (screenPrintData) {
      const modifiedData = screenPrintData.map((row, index, array) => {
        if (
          index > 0 &&
          row.master_invoice_id === array[index - 1].master_invoice_id &&
          row.FINISHED_ITEM === array[index - 1].FINISHED_ITEM &&
          row.master_invoice_id > -1
        ) {
          return {
            ...row,
            INVOICE_DATE: "",
            INVOICE_NO: "",
            FINISHED_ITEM: "",
          };
        }
        return row;
      });
      setScreenTableData(modifiedData); // Update state instead of a variable
    }
    if (token != null) {
      logInStatus = true;
    }
    if (logInStatus === false || !reportName) {
      return <Redirect to="/login" />;
    }
    if (!props?.location?.state?.data) {
      props.history.push({
        pathname: reportPrintGoBackUrl,
      });
    } else {
      reportPrintGoBackUrl = props?.location?.state?.goBackUrl;
      localStorage.setItem("reportPrintGoBackUrl", reportPrintGoBackUrl);
    }
    // manipulateData();
    // getdata();
    // getAccountsSummary();
  }, []);

  const goBackFun = () => {
    let pathName = props?.location?.state?.goBackUrl;
    props.history.push({
      pathname: pathName,
    });
  };

  const downloadPDF = () => {
    const headers = [props?.location?.state?.headers];
    const rawData = props?.location?.state?.data;
    const pdfData = props.location.state.pdfDataArray;
    const pdfDataArray = pdfData ? pdfData : rawData;
    console.log("pdfDataArray :>> ", pdfDataArray);
    const modifiedPdfDataArray = pdfDataArray.map((row, index, array) => {
      // If it's not the first row, compare with the previous row
      console.log("row", row);

      if (
        index > 0 &&
        row.FINISHED_ITEM &&
        row.FINISHED_ITEM === array[index - 1].FINISHED_ITEM // Compare `FINISHED_ITEM`
      ) {
        // Set columns to empty strings for the current row
        return {
          ...row,
          INVOICE_DATE: "",
          INVOICE_NO: "",
          FINISHED_ITEM: "",
        };
      }
      // Otherwise, return the row as-is
      return row;
    });

    console.log(modifiedPdfDataArray);
    const rowsvalueExtracted = modifiedPdfDataArray.map((item) =>
      Object.values(item)
    );
    console.log("rowsvalueExtracted", rowsvalueExtracted);

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a2",
    });

    const reportName = data.reportName; // Replace with your actual report name
    doc.setFontSize(25);
    doc.text(companyName, 14, 10); // Add a title
    doc.text(reportName, 14, 20); // Add a title
    doc.setFontSize(20);
    doc.text(`NTN: ${compNtn}`, 14, 30); // Add a title
    doc.text(`STRN: ${compStrn}`, 14, 38); // Add a title
    doc.setFontSize(18);
    doc.text(data.criteriaString, 14, 44); // Add a title

    // Generate the table
    doc.autoTable({
      head: headers,
      body: rowsvalueExtracted,
      startY: 46,
      theme: "striped",
      styles: {
        fontSize: 20,
        cellPadding: 2,
      },
      headStyles: { fillColor: [63, 14, 128] },
      didDrawPage: (data) => {
        // Footer example
        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber}`,
          10,
          500
        );
      },
      didParseCell: (data) => {
        // Check the conditions for bolding the rows
        if (
          data.row.raw[2] === "Sub Total" || // Check if the third column is "Sub Total"
          data.row.raw[0] === "Total" // Check if the first column is "Total"
        ) {
          data.cell.styles.fontStyle = "bold"; // Apply bold style
        }
      },
    });

    // Save the PDF
    doc.save(reportName);
  };

  const {
    companyName,
    compNtn,
    compStrn,
    dynamicInvMessage,
    reportName,
    criteria,
    criteriaString,
  } = data;
  return (
    <>
      <Row id="app-body-Invoice" className="app-body-Invoice mt-3">
        <Col xs="12">
          <Row>
            <Col xs="6">
              {" "}
              <h2 style={{ marginLeft: "5px" }} className="">
                {companyName}
              </h2>{" "}
            </Col>
            <Col xs="4">
              <span style={{ marginLeft: "13em" }}>
                <span className=" ">Printed By </span>: (
                <span className="text-success"> {customerName} </span> )
              </span>
            </Col>
            <Col xs="2">
              <span style={{ marginLeft: "0rem" }}>
                <span className=" ">Printed Date </span>: (
                <span className="text-success"> {currentDate} </span> )
              </span>
            </Col>
            <Col xs="12">
              <h4 style={{ marginLeft: "5px" }} className="">
                NTN: {compNtn}
              </h4>{" "}
            </Col>
            <Col xs="12">
              <h4 style={{ marginLeft: "5px" }} className="">
                STRN: {compStrn}
              </h4>{" "}
            </Col>
            <Col xs="8">
              {" "}
              <h3 style={{ marginLeft: "5px" }} className="">
                {dynamicInvMessage}
              </h3>{" "}
            </Col>
            <Col xs="4">
              <div style={{ textAlign: "end" }}>
                {
                  //Friday 13 Dec, 2024  previous print set Conditionally and
                  //New Print PDF button added by Muhammad Ahmad On all reports With Reports Criteria
                }
                {data.hidePdfBtn > 0 ? (
                  <button
                    className="btn btn-primary mx-2"
                    id="printPageButton"
                    onClick={() => {
                      window.document.title = reportName;
                      window.print();
                    }}
                  >
                    Print to PDF!
                  </button>
                ) : (
                  <Button className="btn btn-warning" onClick={downloadPDF}>
                    Print PDF
                  </Button>
                )}
                <button
                  className="btn btn-secondary m-1"
                  id="printPageButton"
                  onClick={() => {
                    goBackFun();
                  }}
                >
                  Back
                </button>
              </div>{" "}
            </Col>

            <Col xs="12">
              <p style={{ marginLeft: "5px" }}>
                <b>Data Criteria: {criteriaString}</b>
              </p>
              {/* {criteria?.map((element, index) => (
                <>
                  <span>
                    {element?.label +
                      ": " +
                      element?.value +
                      (index === criteria?.length - 1 ? "" : ", ")}{" "}
                  </span>
                  {index == 3 ? <br></br> : null}
                </>
              ))} */}
            </Col>
            {screenTableData.length > 0 ? (
              <Col xs="12">
                <ReactstrapTable
                  data={screenTableData}
                  headers={props?.location?.state?.headers}
                  username={props?.location?.state?.username}
                  headerKeyMap={props?.location?.state?.headerKeyMap}
                  totalBold={props?.location?.state?.totalBold}
                />
              </Col>
            ) : (
              <p>Loading data...</p>
            )}
            <Col xs="12">
              <p>
                * <span className="text-danger">Note </span>: All figures
                indicated are in the company's currency (
                <span className="text-success"> {companySymbolCurrency} </span>{" "}
                ) .{" "}
              </p>
            </Col>
          </Row>
          <br></br>
        </Col>
      </Row>
    </>
  );
}
